import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=84cae65a&"
import script from "./NotFound.vue?vue&type=script&lang=ts&"
export * from "./NotFound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84cae65a')) {
      api.createRecord('84cae65a', component.options)
    } else {
      api.reload('84cae65a', component.options)
    }
    module.hot.accept("./NotFound.vue?vue&type=template&id=84cae65a&", function () {
      api.rerender('84cae65a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/NotFound.vue"
export default component.exports